import { render, staticRenderFns } from "./ManageCompanyButton.vue?vue&type=template&id=3ed49f0e"
import script from "./ManageCompanyButton.vue?vue&type=script&lang=ts"
export * from "./ManageCompanyButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports